import { sanitize } from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';
import './UnsubscribeByEmailBanner.scss';

const UnsubscribeByEmailBanner = () => {
  const bannerContent = content.allCustomersEmailPreference;
  return (
    <div className="row mx-0 px-0">
      <div className="col-12 px-0">
        <div className="hero-banner col-lg-9 col-md-12 mt-8 mb-6 pl-2 pl-sm-4 pl-md-6 pr-4">
          <h1>{bannerContent.unsubscribeTitle}</h1>
        </div>
      </div>
    </div>
  );
};
export default UnsubscribeByEmailBanner;
